import { isEmpty } from "lodash"
import React, { useEffect, useState } from "react"
import { Accordion, Button, Col, Form, Modal, Row } from "react-bootstrap"
import { XSquareFill } from "react-bootstrap-icons"
import { useTranslation } from "react-i18next"
import { useAppSelector } from "../../app/hooks"
import ChargeableWeight, { volumeWeight } from "../../components/Tables/ChargeableWeight"
import { maxWeightLimit, SHOPINI_ECONOMY, UNITS } from "../../constants/constants"
import { RootState } from "../../store"
import { countryNamesInEnglish } from "../../utils/commonFunctions"
import ConsolAccordionBody from "./ConsolAccordionBody"

const PostConsolidationModal = ({
    show,
    setShow,
    handleSubmit,
    errors,
    setErrors,
    warehouse,
    country
}: {
    show: string
    setShow: Function
    handleSubmit: Function
    errors: Record<string, any>
    setErrors: Function
    warehouse: number
    country?: string
}) => {
    const { t } = useTranslation()
    const [secondaryBoxes, setSecondaryBoxes] = useState([] as Record<string, any>[])
    const [boxWeightAndDims, setBoxWeightAndDims] = useState({} as Record<string, any>)
    const [selectedBoxes, setSelectedBoxes] = useState([] as string[])
    const [shipments, setShipments] = useState([] as string[][])
    //const [isDisabled, setIsDisabled] = useState(false)
    const { consolBox, error, loading } = useAppSelector((state: RootState) => state.consolidations)
    const [dimsAndWeightUnit, setDimsAndWeightUnit] = useState({} as Record<string, any>)
    const [boxesMeasurements, setBoxesMeasurements] = useState([] as Record<string, any>[])
    const [weightLimitExceeded, setWeightLimitExceeded] = useState(0)
    const [selectedShipments, setSelectedShipments] = useState([] as string[])
    const [weightAndDims, setWeightAndDims] = useState({} as Record<string, any>)
    //const findFormErrors = (customError?: Record<string, any>) => {
    //    let newErrors = {} as Record<string, any>
    //    if (!customError) {
    //        if (error?.payload && error?.payload?.length !== 0) {
    //            error?.payload?.forEach(
    //                (e: ErrorObject) =>
    //                    (newErrors[e?.param?.split(".")[1]] = e.msg)
    //            )
    //        } else if (error?.error && error?.error !== "") {
    //            newErrors["genericError"] = error.error
    //        }
    //    } else {
    //        newErrors[customError?.param] = customError?.msg
    //    }
    //    return newErrors
    //}

    const checkFields = (boxUuid: string) => {
        const box = boxesMeasurements?.find((b: Record<string, any>) => b?.consolidation_box_uuid === boxUuid)
        let status = true
        let issues = {} as Record<string, any>
        if (
            !loading &&
            boxWeightAndDims &&
            boxWeightAndDims?.weight &&
            boxWeightAndDims?.length &&
            boxWeightAndDims?.height &&
            boxWeightAndDims?.width &&
            // dimsAndWeightUnit.weightUnit &&
            // dimsAndWeightUnit.dimsUnit &&
            // isEmpty(errors) &&
            !isEmpty(boxWeightAndDims)
        ) {
            return {
                status,
                issues
            }
        } else {
            // if (isEmpty(boxWeightAndDims)) {
            return {
                status: false,
                issues: {
                    weight:
                        box?.weight || boxWeightAndDims?.weight
                            ? null
                            : `This field is required, and must be more than 0`,
                    length:
                        box?.length || boxWeightAndDims?.length
                            ? null
                            : `This field is required, and must be more than 0`,
                    height:
                        box?.height || boxWeightAndDims?.height
                            ? null
                            : `This field is required, and must be more than 0`,
                    width:
                        box?.width || boxWeightAndDims?.width
                            ? null
                            : `This field is required, and must be more than 0`
                }
            }
            // }
        }
    }

    const generateCode = () => {
        let reqData = {} as Record<string, any>
        if (consolBox?.shippingService === SHOPINI_ECONOMY && country && country !== "") {
            const boxes = {} as Record<string, any[]>

            consolBox?.Children?.forEach((child: Record<string, any>) => (boxes[child?.uuid] = child?.parcels))

            reqData = {
                country,
                boxes,
                dims: boxesMeasurements
            }
        } else
            reqData = {
                consolidation_boxes_measurements: boxesMeasurements,
                shipments: shipments
            }
        handleSubmit(reqData)
    }

    useEffect(() => {
        setSelectedBoxes([])
        setSelectedShipments([])
        setBoxWeightAndDims({})
    }, [])

    useEffect(() => {
        setSecondaryBoxes(consolBox?.Children)
    }, [consolBox?.uuid, JSON.stringify(consolBox?.Children)])

    //useEffect(() => {
    //    checkFields()
    //}, [
    //    loading,
    //    boxWeightAndDims.weight,
    //    boxWeightAndDims.length,
    //    boxWeightAndDims.height,
    //    boxWeightAndDims.width
    //])

    const dimsAndWeight: Record<string, any> = {
        height: {
            dimValue: boxWeightAndDims?.height,
            unitValue: dimsAndWeightUnit.dimsUnit,
            units: [UNITS[`${warehouse}`]?.DIM]
        },
        width: {
            dimValue: boxWeightAndDims?.width,
            unitValue: dimsAndWeightUnit.dimsUnit,
            units: [UNITS[`${warehouse}`]?.DIM]
        },
        length: {
            dimValue: boxWeightAndDims?.length,
            unitValue: dimsAndWeightUnit.dimsUnit,
            units: [UNITS[`${warehouse}`]?.DIM]
        },
        weight: {
            dimValue: boxWeightAndDims?.weight,
            unitValue: dimsAndWeightUnit.weightUnit,
            units: [UNITS[`${warehouse}`]?.WEIGHT]
        }
    }

    const handleSaveBoxDimsAndWeight = (secondaryBoxUuid: string, index: number, secondaryBoxUiId?: string) => {
        const consolBoxesWithMeasurements = boxesMeasurements?.map(
            (b: Record<string, any>) => b?.consolidation_box_uuid
        )
        let validity = checkFields(secondaryBoxUuid)
        console.log(validity)
        if (validity?.status) {
            if (consolBoxesWithMeasurements?.includes(secondaryBoxUuid)) {
                setBoxesMeasurements([
                    ...boxesMeasurements.map((b: Record<string, any>) =>
                        b?.consolidation_box_uuid === secondaryBoxUuid
                            ? {
                                  consolidation_box_uuid:
                                      consolBox?.shippingService === SHOPINI_ECONOMY &&
                                      country &&
                                      country !== ""
                                          ? undefined
                                          : secondaryBoxUuid,
                                  height: boxWeightAndDims?.height || b?.height,
                                  width: boxWeightAndDims?.width || b?.width,
                                  length: boxWeightAndDims?.length || b?.length,
                                  weight: boxWeightAndDims?.weight || b?.weight,
                                  weight_unit: dimsAndWeightUnit?.weightUnit || b?.weightUnit,
                                  box_temp_id:
                                      consolBox?.shippingService === SHOPINI_ECONOMY &&
                                      country &&
                                      country !== ""
                                          ? secondaryBoxUuid
                                          : undefined,
                                  box_ui_id: secondaryBoxUiId || ""
                              }
                            : b
                    )
                ])
            } else {
                setBoxesMeasurements([
                    ...boxesMeasurements,
                    {
                        consolidation_box_uuid:
                            consolBox?.shippingService === SHOPINI_ECONOMY && country && country !== ""
                                ? undefined
                                : secondaryBoxUuid,
                        height: boxWeightAndDims?.height,
                        width: boxWeightAndDims?.width,
                        length: boxWeightAndDims?.length,
                        weight: boxWeightAndDims?.weight,
                        weight_unit: dimsAndWeightUnit?.weightUnit,
                        box_temp_id:
                            consolBox?.shippingService === SHOPINI_ECONOMY && country && country !== ""
                                ? secondaryBoxUuid
                                : undefined,
                        box_ui_id: secondaryBoxUiId || ""
                    }
                ])
            }
            const accordionToggle = document.getElementById(`box-${secondaryBoxUuid}`)?.firstElementChild
                ?.firstElementChild as HTMLElement
            accordionToggle?.click()
            setBoxWeightAndDims({
                height: null,
                width: null,
                length: null,
                weight: null
            })
        } else {
            setErrors({ ...(validity?.issues || {}) })
        }
    }

    const handleRemoveBox = (box: string, index: number, id: string) => {
        let shipmentsWithoutBox = shipments.map((shipment: string[]) =>
            shipment.includes(box) ? shipment.filter((sh) => sh !== box) : shipment
        )
        if (shipmentsWithoutBox[index]?.length === 0) {
            document.getElementById(`shipment-${id}`)?.remove()
        }
        setSecondaryBoxes([
            ...secondaryBoxes,
            consolBox?.Children?.find((child: Record<string, any>) => child.uuid === box)
        ])
        setShipments(
            shipmentsWithoutBox?.length === 0
                ? []
                : shipmentsWithoutBox.filter((shipment) => shipment?.length > 0)
        )
    }

    const getWeight = (boxUuid: string) =>
        ChargeableWeight(
            parseFloat(
                boxesMeasurements.find(
                    (b: Record<string, any>) =>
                        b?.consolidation_box_uuid === boxUuid || b?.box_temp_id === boxUuid
                )?.weight || "0.5"
            ),
            volumeWeight(
                boxesMeasurements.find(
                    (b: Record<string, any>) =>
                        b?.consolidation_box_uuid === boxUuid || b?.box_temp_id === boxUuid
                )?.height || "1",
                boxesMeasurements.find(
                    (b: Record<string, any>) =>
                        b?.consolidation_box_uuid === boxUuid || b?.box_temp_id === boxUuid
                )?.width || "1",
                boxesMeasurements.find(
                    (b: Record<string, any>) =>
                        b?.consolidation_box_uuid === boxUuid || b?.box_temp_id === boxUuid
                )?.length || "1",
                dimsAndWeightUnit?.weightUnit
            )
        )?.toFixed(2)

    return (
        <Modal
            size="xl"
            show={["addWeightAndDims", "breakIntoShipments"].includes(show)}
            onHide={() => {
                setSelectedBoxes([])
                setSelectedShipments([])
                setWeightLimitExceeded(0)
                setBoxWeightAndDims({})
                setShow("")
            }}
            backdrop="static"
            className="consolidation-modal"
            keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title className="text-uppercase">
                    {consolBox?.shippingService === SHOPINI_ECONOMY && country && country !== ""
                        ? `${t("Master console")} - ${countryNamesInEnglish.of(country || "")}`
                        : consolBox?.uuid}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Accordion className="d-block">
                        {consolBox?.Children?.map((secondaryBox: Record<string, any>, index: number) => (
                            <Accordion.Item
                                key={`${secondaryBox?.uuid}-w&d`}
                                eventKey={`${secondaryBox?.uuid}`}
                                id={`box-${secondaryBox?.uuid}`}
                                className="my-2">
                                <Accordion.Header>
                                    {consolBox?.shippingService === SHOPINI_ECONOMY && country && country !== ""
                                        ? secondaryBox?.box_ui_id
                                        : secondaryBox?.uuid?.includes("-")
                                          ? `Box ${index}`
                                          : secondaryBox?.uuid}
                                </Accordion.Header>
                                <Accordion.Body>
                                    <Form>
                                        <Row className="align-items-start">
                                            {Object.keys(dimsAndWeight)?.map((key: string) => (
                                                <ConsolAccordionBody
                                                    dimValue={dimsAndWeight[key].dimValue}
                                                    dimFieldName={key}
                                                    unitFieldName={key === "weight" ? "weightUnit" : "dimsUnit"}
                                                    unitValue={dimsAndWeight[key].unitValue}
                                                    dimsAndWeightUnit={dimsAndWeightUnit}
                                                    setDimsAndWeightUnit={setDimsAndWeightUnit}
                                                    boxWeightAndDims={boxWeightAndDims}
                                                    setBoxWeightAndDims={setBoxWeightAndDims}
                                                    units={dimsAndWeight[key].units}
                                                    setWeightLimitExceeded={setWeightLimitExceeded}
                                                    setSelectedBoxes={setSelectedBoxes}
                                                    boxes={selectedBoxes}
                                                    errors={errors}
                                                    setErrors={setErrors}
                                                    warehouse={warehouse}
                                                />
                                            ))}
                                        </Row>
                                        <Button
                                            className="float-end mb-2 btn btn-primary"
                                            onClick={() =>
                                                handleSaveBoxDimsAndWeight(
                                                    secondaryBox?.uuid,
                                                    index,
                                                    secondaryBox?.box_ui_id
                                                )
                                            }>
                                            {loading ? (
                                                <div className="spinner-border text-light" role="submit"></div>
                                            ) : (
                                                t("Save")
                                            )}
                                        </Button>
                                    </Form>
                                </Accordion.Body>
                            </Accordion.Item>
                        ))}
                    </Accordion>
                </Row>

                {boxesMeasurements?.length === consolBox?.Children?.length && (
                    <Row className="border-top mt-4 pt-4 d-flex justify-content-around">
                        <Col lg={5} className="scrollable">
                            <h2 className="shipments-label text-center">{t("Select Boxes")}</h2>
                            <Form>
                                <Form.Group>
                                    {secondaryBoxes?.map((secondaryBox: Record<string, any>, index: number) => {
                                        const uuid = secondaryBox?.uuid || secondaryBox?.consolidation_box_uuid
                                        return (
                                            <Row
                                                key={uuid}
                                                id={uuid}
                                                className={"my-2 justify-content-between px-0 mx-0"}>
                                                <Col lg={9}>
                                                    <Form.Check
                                                        type="checkbox"
                                                        id={`checkbox-${uuid}`}
                                                        label={
                                                            consolBox?.shippingService === SHOPINI_ECONOMY &&
                                                            country &&
                                                            country !== ""
                                                                ? secondaryBox?.box_ui_id
                                                                : uuid
                                                        }
                                                        value={uuid}
                                                        disabled={
                                                            weightLimitExceeded > maxWeightLimit &&
                                                            !selectedBoxes.includes(uuid)
                                                        }
                                                        onChange={(e: any) => {
                                                            if (e.target.checked) {
                                                                setSelectedBoxes([...selectedBoxes, uuid])
                                                                setSelectedShipments([
                                                                    ...selectedShipments,
                                                                    secondaryBox?.box_ui_id
                                                                ])
                                                                setWeightLimitExceeded(
                                                                    weightLimitExceeded +
                                                                        parseFloat(getWeight(uuid))
                                                                )
                                                            } else {
                                                                setSelectedBoxes(
                                                                    selectedBoxes?.filter(
                                                                        (selectedParcel: string) =>
                                                                            selectedParcel !== uuid
                                                                    )
                                                                )
                                                                setSelectedShipments(
                                                                    selectedShipments?.filter(
                                                                        (selectedShipment: string) =>
                                                                            selectedShipment !==
                                                                            secondaryBox?.box_ui_id
                                                                    )
                                                                )
                                                                setWeightLimitExceeded(
                                                                    weightLimitExceeded -
                                                                        parseFloat(getWeight(uuid))
                                                                )
                                                            }
                                                        }}
                                                    />
                                                </Col>
                                                <Col lg={3}>
                                                    {`${getWeight(uuid)} ${dimsAndWeightUnit?.weightUnit}`}
                                                </Col>
                                            </Row>
                                        )
                                    })}
                                </Form.Group>
                            </Form>
                        </Col>
                        <Col lg={5} className={"scrollable"}>
                            <h2 className="shipments-label text-center">{t("Shipments")}</h2>
                            {shipments.map((shipment: string[], index: number) => (
                                <Row key={`shipment-${shipment[0]}`} className="my-3">
                                    <Col lg={12}>
                                        <span className={"pb-3"} id={`shipment-${shipment[0]}`}>
                                            {`Shipment ${index + 1}`}
                                        </span>
                                        {shipment?.map((box: string, shipmentIndex: number) => (
                                            <div className="px-1 py-2 bg-light d-flex justify-content-between">
                                                <span>
                                                    {consolBox?.shippingService === SHOPINI_ECONOMY &&
                                                    country &&
                                                    country !== ""
                                                        ? `Master Box ${shipmentIndex + 1}`
                                                        : box}
                                                </span>
                                                <span>
                                                    {` ${getWeight(box)} ${dimsAndWeightUnit?.weightUnit}`}

                                                    <XSquareFill
                                                        className="text-danger d-inline mx-1"
                                                        role="button"
                                                        onClick={() =>
                                                            handleRemoveBox(
                                                                box,
                                                                index,
                                                                `shipment-${shipment[0]}`
                                                            )
                                                        }
                                                    />
                                                </span>
                                            </div>
                                        ))}
                                    </Col>
                                </Row>
                            ))}
                        </Col>
                    </Row>
                )}
            </Modal.Body>
            <Modal.Footer>
                {boxesMeasurements?.length === consolBox?.Children?.length && (
                    <>
                        <Button
                            variant="secondary"
                            disabled={weightLimitExceeded > maxWeightLimit || selectedBoxes?.length === 0}
                            onClick={() => {
                                setSecondaryBoxes([
                                    ...secondaryBoxes?.filter(
                                        (child: Record<string, any>) => !selectedBoxes?.includes(child?.uuid)
                                    )
                                ])
                                setShipments([...shipments, selectedBoxes])
                                setWeightLimitExceeded(0)
                                setSelectedBoxes([])
                                setSelectedShipments([])
                            }}>
                            {t("Add Shipment")}
                        </Button>

                        <Button
                            disabled={
                                secondaryBoxes?.length > 0 ||
                                shipments?.length === 0 ||
                                weightLimitExceeded > maxWeightLimit
                            }
                            onClick={() => generateCode()}>
                            {t("Generate Code")}
                        </Button>
                    </>
                )}
            </Modal.Footer>
        </Modal>
    )
}

export default PostConsolidationModal
